import React from "react";
import { Button } from "@mui/material";
import Grid from '@mui/material/Grid2';
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import IconButton from '@mui/material/IconButton';
import Stack from '@mui/material/Stack';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import "./style.css";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialog-paper': {
        width:"600px",
        maxWidth: '1000px',
        minHeight: '250px',
        minWidth:'50%',
    },
    '& .MuiDialogContent-root': {
        padding: theme.spacing(2),
        borderTop: "0px",
    },
    '& .MuiDialogActions-root': {
        padding: theme.spacing(1),
    },
}));

interface ValidationErrorModalProps {
    open: boolean;
    closeValidationModal: () => void;
    validationErrors: Record<string, string[]>;
}

const InnoflexSaveModal: React.FC<ValidationErrorModalProps> = ({ 
    open, 
    closeValidationModal, 
    validationErrors 
}) => {
    // Get the module names (headers) from the validationErrors object
    const headers = Object.keys(validationErrors);
    
    // Calculate the maximum number of errors across all modules to determine rows needed
    const maxErrors = Math.max(...Object.values(validationErrors).map(errors => errors.length));
    
    return (
        <BootstrapDialog
           
            aria-labelledby="customized-dialog-title"
            open={open}
        >
            <IconButton
                sx={(theme) => ({
                    position: 'absolute',
                    right: 8,
                    top: 8,
                    color: '#fff',
                    padding: 0,
                    fontSize: '15px',
                    mt: 1,
                    width:'700px',
                })}
            >
                <i onClick={closeValidationModal} className="fas fa-times crose-icon-mt"></i>
            </IconButton>

            <div className="header-bar-top">
                <h3 className="title-head-mdl">Required Field Validation</h3>
            </div>
            <DialogContent>
                <div className="delete-card-wapper-big">
                    <p className="sub-txt-disc" style={{ color: 'red', backgroundColor:'#ccc', padding:'10px' }}>
                        Please fill in all the below required fields and submit the form.
                    </p>
                    <div className="">
                        <TableContainer 
                            component={Paper} 
                            sx={{ 
                                borderRadius: "0px !important", 
                                mt: 3, 
                                boxShadow: "none",
                                maxHeight: '400px',
                                overflow: 'auto'
                            }}
                        >
                            <Table 
                                size="small" 
                                aria-label="validation errors table" 
                                sx={{ 'table, thead tr th, tbody tr td': { border: 0 } }}
                                stickyHeader
                            >
                                <TableHead>
                                    <TableRow style={{fontSize: '16px', fontWeight: 'bold'}}>
                                        {headers.map((header) => (
                                            <TableCell style={{fontWeight: 'bold', fontSize: '14px'}} key={header}>{header}</TableCell>
                                        ))}
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                  
                                    {/* Create rows based on the maximum number of errors */}
                                    {Array.from({ length: maxErrors }).map((_, rowIndex) => (
                                         
                                        <TableRow key={`row-${rowIndex}`}>
                                            {headers.map((header) => {
                                                const errors = validationErrors[header];
                                                const error = errors[rowIndex] || '';
                                                return (
                                                    <TableCell style={{fontSize: '12px'}} key={`${header}-${rowIndex}`}>
                                                        {error}
                                                    </TableCell>
                                                );
                                            })}
                                        </TableRow>
                                    ))}
                                    
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </div>
                </div>
            </DialogContent>
            <Stack 
                direction="row" 
                spacing={2} 
                sx={{ 
                    justifyContent: "center", 
                    py: 3, 
                    textAlign: "center",
                }}
            >
                <Button 
                    onClick={closeValidationModal} 
                    variant="contained" 
                    sx={{ 
                        backgroundColor: '#2a3fbf !important', 
                        borderRadius: '5px', 
                        px: 4, 
                        py: 1, 
                        textTransform: 'capitalize', 
                        color: '#FFF !important' 
                    }}
                >
                    Ok
                </Button>
            </Stack>
        </BootstrapDialog>
    );
};

export default InnoflexSaveModal;